export default __webpack_public_path__ + "static/media/ripple2.6ba1bd76.png";